exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] .jsYP3AKvq_9aDgJuRR1Aa{margin:10px 18px 15px 18px}.jsYP3AKvq_9aDgJuRR1Aa:hover ._1l292QOa5U0M1KKRme0r_r{color:var(--themePrimary)}", ""]);
// Exports
exports.locals = {
	"markAsCompleted": "jsYP3AKvq_9aDgJuRR1Aa",
	"checkboxText": "_1l292QOa5U0M1KKRme0r_r"
};